// supervisor/EmployeeCarousel.tsx
import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlag, faChevronRight, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import './EmployeeCarousel.css';
import { SupervisionCadenceDto } from '../../../services/weeklySupervision/weeklySupervisionService';
import AvatarImage from '../Avatar/AvatarImage';

interface EmployeeCarouselProps {
    cadenceData: SupervisionCadenceDto[];
    selectedSC: SupervisionCadenceDto | null;
    onSelect: (sc: SupervisionCadenceDto) => void;
}

const EmployeeCarousel: React.FC<EmployeeCarouselProps> = ({
    cadenceData,
    selectedSC,
    onSelect
}) => {
    const scrollContainerRef = useRef<HTMLDivElement>(null);

    const scroll = (direction: 'left' | 'right') => {
        if (scrollContainerRef.current) {
            const scrollAmount = 300;
            const newScrollLeft = direction === 'left' 
                ? scrollContainerRef.current.scrollLeft - scrollAmount 
                : scrollContainerRef.current.scrollLeft + scrollAmount;
            
            scrollContainerRef.current.scrollTo({
                left: newScrollLeft,
                behavior: 'smooth'
            });
        }
    };

    return (
        <div className="employee-carousel-wrapper">
            <h3 className="carousel-title">Support Coordinator</h3>
            <div className="carousel-controls">
                <button className="nav-btn left" onClick={() => scroll('left')}>
                    <FontAwesomeIcon icon={faChevronLeft} />
                </button>
                
                <div className="carousel-track" ref={scrollContainerRef}>
                    {cadenceData.map((sc) => {
                        const isSelected = selectedSC?.scId === sc.scId;
                        // Placeholder ID logic
                        const displayId = sc.scId || sc.scId.substring(0,6); 
                        
                        return (
                            <div 
                                key={sc.scId}
                                className={`employee-card ${isSelected ? 'selected' : ''}`}
                                onClick={() => onSelect(sc)}
                            >
                                <div className="card-avatar">
                                    <AvatarImage 
                                        userId={sc.id} 
                                        size="xs" 
                                        displayName={`${sc.firstName} ${sc.lastName}`}
                                    />
                                </div>
                                <div className="card-info">
                                    <div className="card-name" title={`${sc.firstName} ${sc.lastName}`}>
                                        {sc.firstName} {sc.lastName}
                                    </div>
                                    {/* Placeholder Flags - pending backend update */}
                                    <div className="card-flags">
                                        <FontAwesomeIcon icon={faFlag} className="flag-icon" />
                                        <span>{sc.flagCount} Flags</span> 
                                    </div>
                                </div>
                                {isSelected && <div className="active-indicator" />}
                            </div>
                        );
                    })}
                </div>

                <button className="nav-btn right" onClick={() => scroll('right')}>
                    <FontAwesomeIcon icon={faChevronRight} />
                </button>
            </div>
        </div>
    );
};

export default EmployeeCarousel;